meedy.factory('meedy.roleModel', ['$rootScope', 'meedy.baseModel', 'meedy.roleService',
    function($rootScope, baseModel, roleService) {

	    function RoleModel() {

			var self = this;

			this.roleListCriteria = null;
	
		   	this.getDataPage = function(criteria) {
		   		roleService.getDataPage(criteria).then(
		   			function (dataPage) {
		   				$rootScope.$broadcast(Event.MEEDY.ROLE.GET_DATA_PAGE.SUCCESS, dataPage);
		   			},
		   			function(error) {
		   				$rootScope.$broadcast(Event.MEEDY.ROLE.GET_DATA_PAGE.ERROR, error);
		   			}
		   		)
		    };
		    
		    this.getById = function(id) {
		   		roleService.getById(id).then(
			   		function (role) {
			   			$rootScope.$broadcast(Event.MEEDY.ROLE.GET_BY_ID.SUCCESS, role);
			   		},
			   		function(error) {
			   			$rootScope.$broadcast(Event.MEEDY.ROLE.GET_BY_ID.ERROR, error);
			   		}
			   	)
		    };

            this.save = function(role) {
                roleService.save(role).then(
                    function (savedRole) {
                        $rootScope.$broadcast(Event.MEEDY.ROLE.SAVE.SUCCESS, savedRole);
                        baseModel.broadcastOperationSucceeded();
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.MEEDY.ROLE.SAVE.ERROR, error);
                        baseModel.broadcastOperationFailed();
                    }
                )
            };

            this.update = function(role) {
                roleService.update(role).then(
                    function (savedRole) {
                        $rootScope.$broadcast(Event.MEEDY.ROLE.UPDATE.SUCCESS, savedRole);
                        baseModel.broadcastOperationSucceeded();
                    },
                    function(error) {
                        $rootScope.$broadcast(Event.MEEDY.ROLE.UPDATE.ERROR, error);
                        baseModel.broadcastOperationFailed();
                    }
                )
            };
		
		    this.deleteAll = function(roles) {
		   		roleService.deleteAll(roles).then(
			   		function (data) {
			   			$rootScope.$broadcast(Event.MEEDY.ROLE.DELETE_ALL.SUCCESS, data);
		                baseModel.broadcastOperationSucceeded();
			   		},
			   		function(error) {
			   			$rootScope.$broadcast(Event.MEEDY.ROLE.DELETE_ALL.ERROR, error);
		                baseModel.broadcastOperationFailed();
			   		}
			   	)
		    };

			$rootScope.$on(Event.MODULE_CHANGED, function(event, fromModule, toModule) {
				if (fromModule == Constant.MODULE.ROLES) {
					self.roleListCriteria = null;
				}
			});
	
	    }
	
	    return new RoleModel();
	}
]);
